<template>
  <div class="field">
    <label>Adresse mail</label>
    <a-input
      type="text"
      v-model:value="user.email"
    ></a-input>
  </div>
  <div class="field">
    <label>Mot de passe</label>
    <a-input
      type="password"
      v-model:value="user.password"
    ></a-input>
  </div>

  <div style="text-align: right; margin-top: 10px">
    <a-button @click="login()" :loading="loading" type="primary" shape="round" ghost>
      Connexion
    </a-button>
  </div>
</template>


<script>
export default {
  name: "createUser",
  props: {
    errorData: {
      type: Object,
    },
  },
  data: () => {
    return {
      loading: false,
      user: {
        email: "",
        password: "",
      },
    };
  },
  methods: {
    async login() {
      this.loading = true;
      this.errorData.show = false;
      localStorage.clear();

      await this.$axios
        .post("auth/login", this.user)
        .then((r) => {
          if (r.status === 200) {
            localStorage.setItem("broker_token", r.data.access_token);
            window.location.href = "/";
          }
        })
        .catch((e) => {
          this.errorData.message = e.response.data.message;
          this.errorData.is_courtier = e.response.data.is_courtier;
          this.errorData.show = true;
        }).finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
